export function OrganizationAuthorityStep() {
  return (
          <fieldset className="wide-field">
            <legend>2. Edustusoikeus</legend>
            <div className="application-field-grid">
              <label>
                Vastuuhenkilön nimi
                <input
                  name="representativeName"
                  minLength={2}
                  maxLength={200}
                  required
                  defaultValue=""
                />
              </label>
              <label>
                Rooli organisaatiossa
                <input
                  name="representativeTitle"
                  minLength={2}
                  maxLength={120}
                  required
                  placeholder="Puheenjohtaja, toiminnanjohtaja…"
                />
              </label>
              <label className="wide-field">
                Edustusoikeuden peruste
                <textarea
                  name="authorityBasis"
                  minLength={4}
                  maxLength={1000}
                  required
                  rows={3}
                  placeholder="Esim. hoitokunnan päätös, säännöt tai valtakirja"
                />
              </label>
              <label>
                Voimassa asti <small>valinnainen</small>
                <input name="authorityValidUntil" type="date" />
              </label>
              <label>
                Todiste (HTTPS)
                <input
                  name="authorityEvidenceUrl"
                  type="url"
                  pattern="https://.*"
                  required
                  placeholder="Pöytäkirja, säännöt tai valtakirja"
                />
              </label>
            </div>
          </fieldset>
  );
}

